import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { Button, Divider } from "@walmart-web/livingdesign-components"
import { Rate, Text } from "components/Shared/Cards/SummaryCard/components"
import SummaryCard from "components/Shared/Cards/SummaryCard"
import { cards } from "./constants"
import "./index.scss"

interface CardsProps {}

const Cards: React.FC<CardsProps> = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false)

	return (
		<React.Fragment>
			<div className="cards-container">
				{cards.map((card) => (
					<SummaryCard
						key={`summarycard-${card.title}`}
						{...card}
						isOpen={isOpen}
					>
						{card.collapse.rates.map((props) => (
							<Rate key={`rates-collapse-${props.title}`} {...props} />
						))}
						<Divider />
						{card.collapse.preferences.map((props) => (
							<Text key={`preferences-collapse-${props.title}`} {...props} />
						))}
						<Divider />
						<Text {...card.collapse.description} classname="description" />
					</SummaryCard>
				))}
			</div>
			<div className="cards-button">
				<Button onClick={() => setIsOpen(!isOpen)}>
					<FormattedMessage id="phronesis.customerbehavior.application.customerProfiling.habits.collapse" />
				</Button>
			</div>
		</React.Fragment>
	)
}

export default Cards
